const Dot = ({ index, currentIndex, onClick }) => {
	const selected = index === currentIndex;
	return (
		<li
			className={`intro-nav-list ${selected ? "active" : ""}`}
			onClick={() => onClick(index)}
		>
			<button></button>
		</li>
	);
};


export const Dots = ({ limit, currentIndex, onDotClick }) => {
	return (
		<div
			className="intro-nav-wrap"
		>
			<ul>
				{Array(limit)
					.fill("")
					.map((_, index) => (
						<Dot
							key={index}
							index={index}
							currentIndex={currentIndex}
							onClick={onDotClick}
						></Dot>
					))}
			</ul>
		</div>
	);
};